import {
  BankAggregate,
  DispensaryAggregate,
  FincenDepositAggregate,
  FincenReportAggregate,
  SalesAggregate,
} from '../../typings/aggregates';
import { AggregatesActionTypes } from './aggregates.actions';

const formatAggregate = (action: any) => {
  const aggregate = {};
  aggregate[action.payload.id] = action.payload.data;
  return aggregate;
};

export interface AggregatesState {
  dispensaryAggregate:
    | {
        [key: string]: DispensaryAggregate | {};
      }
    | {};
  bankAggregate:
    | {
        [key: string]: BankAggregate | {};
      }
    | {};
  fincenDepositAggregate:
    | {
        [key: string]: FincenDepositAggregate | {};
      }
    | {};
  salesAggregate:
    | {
        [key: string]: SalesAggregate | {};
      }
    | {};
  fincenReportAggregate: FincenReportAggregate[] | [];
}

export const initialAggregateState: AggregatesState = {
  dispensaryAggregate: {},
  bankAggregate: {},
  fincenDepositAggregate: {},
  salesAggregate: {},
  fincenReportAggregate: [],
};

export function aggregatesReducer(state = initialAggregateState, action): AggregatesState {
  switch (action.type) {
    case AggregatesActionTypes.BankAggregateLoaded:
      return {
        ...state,
        bankAggregate: {
          ...state.bankAggregate,
          ...formatAggregate(action),
        },
      };
    case AggregatesActionTypes.DispensaryAggregateLoaded:
      return {
        ...state,
        dispensaryAggregate: {
          ...state.dispensaryAggregate,
          ...formatAggregate(action),
        },
      };
    case AggregatesActionTypes.FincenDepositAggregateLoaded:
      return {
        ...state,
        fincenDepositAggregate: {
          ...state.fincenDepositAggregate,
          ...formatAggregate(action),
        },
      };
    case AggregatesActionTypes.FincenReportAggregateLoaded:
      return {
        ...state,
        fincenReportAggregate: action.payload,
      };
    case AggregatesActionTypes.SalesAggregateLoaded:
      return {
        ...state,
        salesAggregate: {
          ...state.salesAggregate,
          ...formatAggregate(action),
        },
      };
    case AggregatesActionTypes.ResetAggregates:
      return initialAggregateState;
    default:
      return state;
  }
}
